module.exports = __webpack_public_path__ + "img/uttlesford.603dd083.jpg";